export default __webpack_public_path__ + "static/media/Declaration of Independence_04.a533509c.jpg";